import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrap = styled.footer`
  margin-top: 120px;
  border-top: 1px solid var(--border);
  background: linear-gradient(180deg, transparent, rgba(124, 92, 255, 0.05));
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 64px 24px 32px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.2fr;
  gap: 48px;
  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 36px;
  }
`;

const Col = styled.div``;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.15rem;
  margin-bottom: 14px;
`;

const Mark = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
  filter: drop-shadow(0 6px 16px rgba(61, 214, 255, 0.3));
`;

const Tag = styled.p`
  color: var(--text-dim);
  line-height: 1.6;
  font-size: 0.95rem;
  max-width: 360px;
  margin: 0;
`;

const Heading = styled.h4`
  margin: 0 0 16px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--text-mute);
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
`;

const FLink = styled(Link)`
  color: var(--text-dim);
  font-size: 0.95rem;
  transition: color 0.2s ease;
  &:hover {
    color: var(--text);
  }
`;

const Contact = styled.div`
  display: grid;
  gap: 12px;
  color: var(--text-dim);
  font-size: 0.95rem;
  a {
    color: var(--text-dim);
    transition: color 0.2s ease;
    &:hover { color: var(--text); }
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Bottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 36px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-mute);
  font-size: 0.85rem;
  @media (max-width: 560px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Icon = ({ d }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

export default function Footer() {
  return (
    <Wrap>
      <Inner>
        <Col>
          <Brand>
            <Mark src="/zi-logo.png" alt="Zero Immersive" />
            Zero Immersive
          </Brand>
          <Tag>
            A Canadian mobile game studio crafting puzzle, simulator, and arcade
            experiences that pull players in and don't let go.
          </Tag>
        </Col>
        <Col>
          <Heading>Explore</Heading>
          <List>
            <li><FLink to="/">Home</FLink></li>
            <li><FLink to="/about">About & Contact</FLink></li>
            <li><FLink as="a" href="/terms.html">Terms of Service</FLink></li>
            <li><FLink as="a" href="/privacy.html">Privacy Policy</FLink></li>
          </List>
        </Col>
        <Col>
          <Heading>Studio</Heading>
          <Contact>
            <Row>
              <Icon d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              Mississauga, Ontario, Canada
            </Row>
            <Row>
              <Icon d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6" />
              <a href="mailto:accounts@zeroimmersive.com">accounts@zeroimmersive.com</a>
            </Row>
            <Row>
              <Icon d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              <a href="tel:+16475104511">+1 (647) 510-4511</a>
            </Row>
          </Contact>
        </Col>
      </Inner>
      <Bottom>
        <span>© {new Date().getFullYear()} Zero Immersive Inc. All rights reserved.</span>
        <span>Crafted in Canada · Played worldwide</span>
      </Bottom>
    </Wrap>
  );
}
